import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_warehouse_site: { message: "idle" },
};

export const add_warehouse_site_Slice = createSlice({
 name: "add_warehouse_site",
 initialState,
 reducers: {
  success_add_warehouse_site: (state, action) => {
   state.add_warehouse_site = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_warehouse_site: (state, action) => {
   state.add_warehouse_site = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_warehouse_site: (state) => {
   state.add_warehouse_site = { status: app_consts.IDLE };
  },
  loading_add_warehouse_site: (state) => {
   state.add_warehouse_site = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_warehouse_site, fail_add_warehouse_site, reset_add_warehouse_site, loading_add_warehouse_site } = add_warehouse_site_Slice.actions;

export default add_warehouse_site_Slice.reducer;